export const bgColorVertexShader = `#version 300 es

in vec2 a_position;

uniform mat3 u_camViewProjection;
uniform mat3 u_model;

void main() {
    mat3 u_matrix = u_camViewProjection * u_model;
    vec3 position = u_matrix * vec3(a_position, 1);
    gl_Position = vec4(position, 1);
}
`;

export const bgColorFragmentShader = `#version 300 es

precision highp float;

uniform float u_opacity;
uniform vec4 u_color;

out vec4 outColor;

void main() {
  float alpha = u_color.a * u_opacity;

  if (alpha <= 0.0) {
    discard;
  }

  outColor = vec4(u_color.rgb, alpha);
}
`;
